import authInstance from "../Interceptor/interceptor";

export const addAttenderEffect = (attenderData) => {
    return authInstance.post("/patients/insertattender", attenderData);
};

export const deleteAttenderEffect = (id) => {
    return authInstance.delete(`/attender/delete/${id}`);
};

export const editAttenderEffect = (id, formData) => {
    return authInstance.put(`/attenderbooking/updateattender/${id}`, formData);
};
export const ViewAttenderEffect = (StaffID, attenderId) => {
    return authInstance.get(`/patients/getattenserbystaff?staff_id=${StaffID}&patient_id=${attenderId}`);
};
export const listAttenderEffect = (pageNo) => {
    return authInstance.get(`/attenders/list/${pageNo}`);
};

export const historyAttenderEffect = (pageNo) => {
    return authInstance.get(`/attenderbooking/getbysecirity?pageNo=${pageNo}&pagesize=10`);
};